import { render, staticRenderFns } from "./KAddress.vue?vue&type=template&id=4cd4ad80&"
import script from "./KAddress.vue?vue&type=script&lang=js&"
export * from "./KAddress.vue?vue&type=script&lang=js&"
import style0 from "./KAddress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports